/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import ProviderForm from "components/forms/ProviderForm";
import { ProviderInterface, UserRolesEnum } from "medicalsystem-shared";
import { FormActionType } from "types/form.enum";

/**
 * Component for creating new provider (doctor/nurse) records.
 * Displays provider form with mock default data for development/testing.
 * 
 * @returns New provider form component
 */
const NewProviderDataContent = () => {
  const provider: ProviderInterface = {
    person: {
      name: "Jhon",
      lastname: "Doe",
      user: {
        email: "doe.jhon@med.com",
        roles: [UserRolesEnum.DOCTOR],
        username: "jhonDoe",
      },
    },
    deaRegistration: "CS1234567",
    medicalLicense: "ABC123",
    specialty: "Pediatrician",
  };

  return <ProviderForm model={provider} />;
};

export default NewProviderDataContent;
